'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_s8mp0_1";
const checkbox = "_checkbox_s8mp0_13";
const label = "_label_s8mp0_57";
const styles = {
	root: root,
	checkbox: checkbox,
	label: label
};

const Checkbox = (_a) => {
  var { children, className, validationBehavior = "native" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "validationBehavior"]);
  return jsxRuntime.jsx(reactAriaComponents.Checkbox, Object.assign({ className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.root, className], renderProps), "data-zds": true, validationBehavior, "data-has-no-visible-label": React__default.default.Children.count(children) === 0 ? true : void 0 }, props, { children: (checkboxRenderProps) => jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("div", { className: styles.checkbox, "data-zds": true, children: jsxRuntime.jsx("svg", { viewBox: "0 0 18 18", "aria-hidden": "true", "data-zds": true, children: checkboxRenderProps.isIndeterminate ? jsxRuntime.jsx("rect", { x: 0, y: 7, width: 18, height: 4 }) : checkboxRenderProps.isSelected && jsxRuntime.jsx("polyline", { points: "2 9 8 14 16 4" }) }) }), jsxRuntime.jsx("div", { className: styles.label, children: typeof children === "function" ? children(checkboxRenderProps) : children })] }) }));
};

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.cjs.js.map
